import ServiceCard from '@/components/base/ServiceCard';
import { services } from '@/mocks/services';

export default function ServicesPreview() {
  const featuredServices = services.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-sm font-medium rounded-full mb-4">
            我们的服务
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            六大品类 · 全天候守护
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            从深夜咨询到凌晨配送，从紧急支援到健康守护，覆盖你凌晨可能遇到的一切需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredServices.map((service) => (
            <ServiceCard
              key={service.id}
              name={service.name}
              description={service.description}
              price={service.price}
              imageUrl={service.imageUrl}
              tags={service.tags}
              category={service.category}
            />
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/categories"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-200 text-primary-600 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-50 transition-colors cursor-pointer"
          >
            查看全部12项服务
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}